"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Box = _interopRequireDefault(require("../Box/Box"));

var Flex = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Flex",
  componentId: "sc-1paa0i6-0"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " display:flex;"], _styledSystem.justifyContent, _styledSystem.alignItems, _styledSystem.flexDirection, _styledSystem.flexWrap, _styledSystem.flexBasis, _styledSystem.flex, _styledSystem.justifySelf, _styledSystem.justifyItems, _styledSystem.order);
Flex.propTypes = (0, _extends2["default"])({}, _Box["default"].propTypes, {}, _styledSystem.justifyContent.propTypes, {}, _styledSystem.alignItems.propTypes, {}, _styledSystem.flexDirection.propTypes);
Flex.defaultProps = (0, _extends2["default"])({}, _Box["default"].defaultProps, {
  justifyContent: "flex-start",
  alignItems: "flex-start",
  flexDirection: "row"
});
var _default = Flex;
exports["default"] = _default;